import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardImg, CardBody, Button, Badge, Spinner } from "reactstrap";
import Handler from "../Helpers/Handler";
import { getCookie } from "../Helpers/Utils";
import { useNavigate } from "react-router-dom";
import SuperMarket from '../Assets/images/Supermaerket33.jpg'

const Products = () => {
  const sessionId = getCookie("sessionToken");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [visibleCount, setVisibleCount] = useState(8);
  const [categories, setCategories] = useState([]);
  const [activeCat, setActiveCat] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [cartItemsMap, setCartItemsMap] = useState({});
  const [cartData, setCartData] = useState({ items: [], total: 0 });
  const [busyProduct, setBusyProduct] = useState(null);

  const loadProducts = async () => {
    if (!sessionId) return;
    setLoading(true);
    try {
      const response = await Handler({ method: "post", url: `/qr/menu.php`, data: { session_id: sessionId } });
      const menu = response?.menu ?? response?.data?.menu ?? [];
      setProducts(menu); setFilteredList(menu);
      setCategories([...new Set(menu.map(m => m.category_name || "Uncategorized"))]);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const getCart = async () => {
    if (!sessionId) return;
    try {
      const response = await Handler({ method: "get", url: `/cart/get.php?session_id=${sessionId}` });
      if (response?.success) {
        const cart = response.cart;
        setCartData(cart);
        const map = {}; cart.items?.forEach(i => map[i.product_id] = Number(i.qty));
        setCartItemsMap(map);
      } else { setCartData({ items: [], total: 0 }); setCartItemsMap({}); }
    } catch (err) { console.error(err); }
  };

  useEffect(() => { loadProducts(); getCart(); }, []);

  const handleFilter = (cat) => { setActiveCat(cat); setFilteredList(!cat ? products : products.filter(p => (p.category_name || "").toLowerCase() === cat.toLowerCase())); setVisibleCount(9); };

  const optimisticUpdate = async ({ productId, newQty, apiCall }) => {
    const prev = { ...cartItemsMap };
    setBusyProduct(productId);
    try {
      setCartItemsMap((m) => ({ ...m, [productId]: newQty }));
      const res = await apiCall();
      if (!res?.success) { setCartItemsMap(prev); return false; }
      await getCart();
    } catch { setCartItemsMap(prev); }
    setBusyProduct(null);
    return true;
  };

  const updateCart = async (productId, qty) => {
    if (!sessionId) return alert("Session expired");
    if (qty <= 0) return optimisticUpdate({ productId, newQty: 0, apiCall: () => Handler({ method: "post", url: "/cart/remove.php", data: { session_id: sessionId, product_id: productId } }) });
    optimisticUpdate({ productId, newQty: qty, apiCall: () => Handler({ method: "post", url: "/cart/add.php", data: { session_id: sessionId, products: [{ product_id: productId, qty }] } }) });
  };

  const addToCart = (id) => updateCart(id, 1);
  const increase = (id) => updateCart(id, (cartItemsMap[id] || 0) + 1);
  const decrease = (id) => updateCart(id, (cartItemsMap[id] || 0) - 1);

  const visibleItems = filteredList.slice(0, visibleCount);

  return (
    <React.Fragment>
      <div>
        <img className="market-img" src={SuperMarket} alt="supermarket" />
      </div>
      <div className="menu-wrapper">
        <Container>
          {/* CATEGORY FILTER */}
          <div className="filter-scroll">
            <div className="filter-icon"><i className="bx bx-filter-alt" /></div>
            <button className={`filter-chip ${activeCat === "" ? "active" : ""}`} onClick={() => handleFilter("")}>All</button>
            {categories.map((c, i) => (
              <button key={i} className={`filter-chip ${activeCat === c ? "active" : ""}`} onClick={() => handleFilter(c)}>{c}</button>
            ))}
          </div>

          {loading && <div className="loading-box"><Spinner color="primary" /></div>}

          {/* PRODUCT LIST */}
          <Row className="mt-4 justify-content-center">
            {visibleItems.length ? visibleItems.map((p) => {
              const qty = cartItemsMap[p.product_id] || 0;
              const disabling = busyProduct === p.product_id;
              return (
                <Col key={p.product_id} xl="3" lg="4" md="6" sm="6" xs="12" className="mb-4">
                  <Card className="product-card shadow-sm">
                    <CardImg top src={p.image || "https://via.placeholder.com/400x300"} alt={p.name} className="product-image" />
                    <CardBody>
                      <div className="product-header">
                        <h5 className="product-title">{p.name}</h5>
                        <Badge color="warning">{p.category_name || "—"}</Badge>
                      </div>
                      <p className="product-desc">{p.description || "No description."}</p>

                      <div className="product-price">
                        <span className="price-text">₹ {p.price}</span>
                        <span className="unit-text">{p.unit}</span>
                      </div>

                      {qty === 0 ? (
                        <Button className="w-100 mt-3 placeorder-btn add-order-btn" disabled={disabling} onClick={() => addToCart(p.product_id)}>
                          {disabling ? <Spinner size="sm" /> : "Add to Cart"}
                        </Button>
                      ) : (
                        <div className="cart-qty-box">
                          <Button color="danger" disabled={disabling || qty === 1} onClick={() => decrease(p.product_id)}>-</Button>
                          <span className="qty-display">{qty}</span>
                          <Button color="success" disabled={disabling} onClick={() => increase(p.product_id)}>+</Button>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              );
            }) : (
              <Col xs="12" className="text-center text-muted">No Products Found</Col>
            )}
          </Row>

          {visibleCount < filteredList.length && (
            <div className="load-more-section"><Button color="primary" className="load-more-btn" onClick={() => setVisibleCount((v) => v + 9)}>Load More</Button></div>
          )}

        </Container>

        {/* BOTTOM CART BAR */}
        {cartData.items?.length > 0 && (
          <div className="bottom-cart-bar">
            <div className="cart-left">
              <h4 className="m-0">₹ {cartData.total}</h4>
              <small className="text-muted">Subtotal • {cartData.items.length} {cartData.items.length > 1 ? "items" : "item"}</small>
            </div>
            <button className="cart-button" onClick={() => navigate("/cart")}>Continue to Cart</button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Products;
